import { Component, OnInit } from "@angular/core";
import { RewardsService } from "./rewards.service";
import { UserService } from "../services/user/user.service";
import { Router } from "@angular/router";
import { BaseReward, RewardSource, RewardType } from "@models/reward.model";
import { environment } from "../../environments/environment";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: "app-rewards",
    templateUrl: "./rewards.component.html",
    styleUrls: ["./rewards.component.scss"],
    standalone: false,
})
export class RewardsComponent implements OnInit {
    public rewards: BaseReward[] = [];
    public totalBalance: number = 0;
    public totalRewards = 0;
    public userId!: number;
    public loading: boolean = true;
    public pageIndex = environment.dynamicPagination.pageIndex;
    public pageSize = environment.dynamicPagination.pageSize;
    public totalRewardsCount!: number;
    public RewardType = RewardType;

    constructor(
        private rewardsService: RewardsService,
        private userService: UserService,
        private router: Router,
        private translate: TranslateService,
    ) {}

    ngOnInit() {
        this.userService.getUserDetails().subscribe((response) => {
            if (response) {
                this.userId = response.id;
                this.getRewardsData(this.userId);
            }
        });
    }

    public getRewardsData(userId: number): void {
        this.loading = true;
        this.rewardsService.getRewardsWithTotalCountForUser(userId, this.pageIndex, this.pageSize).subscribe(
            (data) => {
                this.rewards = [...this.rewards, ...data.rows];
                this.totalRewardsCount = data.count;
                this.totalBalance = data.balance;
                this.loading = false;
            },
            (error) => {
                this.loading = false;
            },
        );
    }

    public calculateTotalBalance(totalCoinsEarned: number, totalCoinsSpent: number): number {
        return totalCoinsEarned - totalCoinsSpent;
    }

    public showViewMoreButton(): boolean {
        return this.rewards.length < this.totalRewardsCount && this.rewards.length >= this.pageSize;
    }

    public loadMoreRewards(): void {
        if (this.pageIndex * this.pageSize < this.totalRewardsCount) {
            this.pageIndex++;
            this.getRewardsData(this.userId);
        }
    }

    public goToHomePage(): void {
        this.router.navigate(["/home"]);
    }

    private getTranslation(key: string, params?: object): string {
        return this.translate.instant(key, params);
    }

    public getDisplayName(reward: BaseReward): string {
        switch (reward.source) {
            case RewardSource.Structure:
                return reward.type === RewardType.Credited
                    ? this.getTranslation("reward.transaction.title.structure", { structureId: reward.structureId })
                    : this.getTranslation("reward.transaction.title.unknown");

            case RewardSource.Order:
                return reward.type === RewardType.Debited
                    ? this.getTranslation("reward.transaction.title.order", { orderId: reward.orderId })
                    : this.getTranslation("reward.transaction.title.unknown");

            case RewardSource.Refund:
                return reward.type === RewardType.Credited
                    ? this.getTranslation("reward.transaction.title.refund", { orderId: reward.orderId })
                    : this.getTranslation("reward.transaction.title.unknown");

            default:
                return this.getTranslation("reward.transaction.title.unknown");
        }
    }

    public goBack() {
        this.router.navigate(["/account"]);
    }
}
